export default "__VITE_ASSET__DZLOr7mM__"